import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";

export const useListaProcesuHarm = (rejestrId, enabled = true) => {

    return useQuery({
        queryKey: [`lista_procesow_harm`, rejestrId],
        queryFn: () => getList(`/oper/plan-harm/proces/${rejestrId}`),
        enabled: enabled
    })
}